export default function UserBookingsFactory(Resources, Locations, $q, moment) {
    var fn = this;

    const removeArrayDublicates = (array) => {
        return array.filter((item, index) => {
            return array.indexOf(item) === index;
        });
    };

    fn.extractStartTimeFromBookingPeriods = (bookingPeriods) => {
        const times = bookingPeriods.map((bp) => {
            return moment(bp.start);
        });

        let sortedTimes = times.sort((a, b) => a.unix() - b.unix());

        return moment(sortedTimes[0]).format();
    };

    fn.extractThenGetFlatArrayOfResourcesAsync = (bookings) => {
        let array = [];

        bookings.map((booking) => {
            booking.bookingPeriods.map((bp) => {
                array.push(bp.resourceId);
                array.push(bp.resource.parentId);
            });
        });

        const uniqueResourceIds = removeArrayDublicates(array);

        // console.log(uniqueResourceIds);
        // const sweetArray = [2, 3, 4, 5, 35];
        const promises = uniqueResourceIds.map((id) => {
            return Resources.get(id);
        });

        return $q.all(promises).then(
            (res) => {
                return $q.resolve(res);
            },
            (err) => {
                return $q.reject(err);
            }
        );
    };

    /** NOT in use (legacy) **/
    fn.processBookings = (bookings) => {
        const currentDate = new Date();

        // RESET
        let future = [];
        let past = [];

        // DIVIDE BOOKINGS IN Past AND future

        bookings.forEach((booking) => {
            // const booking = angular.copy(bookings[i]);
            const bookingStart = new Date(booking.start);

            // Future bookings
            if (bookingStart > currentDate) {
                future.push(booking);
            }

            // Past bookings
            if (bookingStart < currentDate) {
                past.push(booking);
            }
        });

        return {
            past: past,
            future: future,
        };
    };

    return fn;
}
